module.exports = __webpack_public_path__ + "static/img/tabbar_paipailogo.f8259346.png";